import { Handle, NodeProps, Position } from 'reactflow';
import { BarChart3 } from 'lucide-react';
import { PipelineNodeData } from '../../types/pipeline';

export default function AggregationNode({ data, selected }: NodeProps<PipelineNodeData>) {
  return (
    <div
      className={`rounded-lg border bg-white px-3 py-2 shadow-sm ${
        selected ? 'border-orange-500 ring-2 ring-orange-200' : 'border-orange-200'
      }`}
    >
      <Handle type="target" position={Position.Left} className="!bg-orange-500" />
      <Handle type="source" position={Position.Right} className="!bg-orange-500" />
      <div className="flex items-center gap-2 text-sm font-semibold text-orange-700">
        <BarChart3 className="h-4 w-4" />
        <span>{data.label}</span>
      </div>
      {data.description && (
        <p className="mt-1 text-xs text-slate-500">{data.description}</p>
      )}
    </div>
  );
}
